import client from "./client";

export const deviceStatus = async () => (await client.get("/devices/status")).data;

export const sendTestPush = async () => (await client.post("/devices/test")).data;
